import { Typography } from 'omakase';
import { core } from '@tock/coretypes';
import _ from 'lodash';

interface Props {
  parkingOptionsOffered: core.BusinessParkingOption.ParkingOption[];
}

const parkingOptionDisplayNameMap: {
  [K in core.BusinessParkingOption.ParkingOption]: string;
} = {
  ON_SITE: 'on-site',
  VALET: 'valet',
  STREET: 'street parking',
};

const ParkingInformation: React.FunctionComponent<Props> = ({ parkingOptionsOffered }) => {
  const parkingString = `Parking: ${_.capitalize(
    parkingOptionsOffered
      .map((option) => parkingOptionDisplayNameMap[option])
      .sort()
      .join(', ')
  )}`;

  return (
    <Typography component="span" data-testid="parking-information-primary" variant="body02">
      {parkingOptionsOffered.length > 0 && parkingString}
    </Typography>
  );
};

export default ParkingInformation;
